import { type OperationVariables, type QueryHookOptions, useQuery } from '@apollo/client';
import { buildMetaQ, buildSharedMeta } from 'src/dynamoQueries/queryHelpers';

export function useMetaQ<TData = unknown, TVariables extends OperationVariables = OperationVariables>(
  useQueryArgs?: QueryHookOptions<TData, TVariables>,
  shared = false,
) {
  const query = shared ? buildSharedMeta() : buildMetaQ();
  return useQuery<TData, TVariables>(query, useQueryArgs);
}
